export default "__VITE_ASSET__CTRedZ0s__"